import { bindUrl, request } from "./request";
/**
 * 授权登录
 * POST /oil/authorize/login
 * @param {授权登录} bodyParams - authorizeLoginReq
 */
export function login(bodyParams) {
  return request({
    url: bindUrl("/oil/app/authorize/login", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 授权登录
 * POST /oil/authorize/login
 * @param {授权登录} bodyParams - authorizeLoginReq
 */
export function traderAutoLogin(bodyParams) {
  return request({
    url: bindUrl("/uaa/user/wxLogin", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 身份证上传
 * POST /oil/app/client/information
 * @param {ClientUploadIdCardReq} bodyParams - clientUploadIdCardReq
 */
export function weixinLogin(bodyParams) {
  return request({
    url: bindUrl("/oil/app/client/information", {}),
    method: "POST",
    data: bodyParams
  });
}

export function userIss(queryParams) {
  return request({
    url: bindUrl("/blade-user/iss", {}),
    method: "GET",
    params: queryParams
  });
}
